
export const datepickerLight = "chakra-input css-1c6j008"
export const datepickerDark = "chakra-input css-xpongc"
